module.exports = __webpack_public_path__ + "img/slidesmall.90b7b1b7.png";